import { CSSProperties, FC } from "react";
import classes from "./style.module.scss";
import { IoMdRadioButtonOn } from "react-icons/io";

const RadioButtonBorder: FC<{
  data: Array<{ [key: string]: string | number }>;
  value: string | number;
  pointer: { label: string; value: string };
  displayType?: "horizontal" | "vertical";
  labelPositon?: "right" | "left";
  onChange: (value: string | number) => void;
  styles?: CSSProperties;
  className?: string;
}> = ({
  data = [],
  value = "",
  pointer = { label: "label", value: "value" },
  displayType = "horizontal",
  labelPositon = "right",
  onChange,
  styles = {},
  className,
}) => {
    return (
      <div
        className={`mt_8 ${classes.container} flex w-full overflow-x-auto`}
        data-view={displayType}
        style={styles}
      >
        <div className="flex gap-2 min-w-max">
          {data.map((item) => (
            <span
              key={`radio-${item[pointer.value]}`}
              className={`flex flex-shrink-0 cursor-pointer br-10 px-[10px] py-[5px] bg-white items-center whitespace-nowrap
          ${classes.radio}
          ${value === item[pointer.value] ? "border-primary" : "border"}
          ${className}`}
              onClick={() => onChange(item[pointer.value])}
            >
              <IoMdRadioButtonOn
                className={
                  value === item[pointer.value]
                    ? classes.active
                    : "color-sub-text"
                }
              />
              <span
                className={`fs-12 ml-1 ${value === item[pointer.value]
                    ? "color-primary"
                    : "color-sub-text"
                  }`}
              >
                {item[pointer.label]}
              </span>
            </span>
          ))}
        </div>
      </div>
    );
  };

export default RadioButtonBorder;